// src/store/useAppStore.js
import { create } from "zustand";

export const useAppStore = create((set) => ({
  // form inputs
  appName: "",
  appDesc: "",

  // progress/loader
  currentStep: null, // null = hidden, 0..9 = active step index
  setCurrentStep: (step) => set({ currentStep: step }),

  // firestore + generated data
  collections: [],
  generatedJSON: null,

  // setters
  setAppName: (name) => set({ appName: name }),
  setAppDesc: (desc) => set({ appDesc: desc }),
  setCollections: (cols) => set({ collections: cols }),
  setGeneratedJSON: (json) => set({ generatedJSON: json }),

  // optional helpers
  resetProgress: () => set({ currentStep: null }),
  resetForm: () => set({ appName: "", appDesc: "" }),
}));
